import StrikezoneGameCompare from './StrikezoneGameCompare';

export default StrikezoneGameCompare;
